// @flow
import { int } from "../helpers/types";
import modelImage from "./image";
import type { Image, ImageApiItem } from "./image";

export type Category = {
  id: number,
  title: string,
  weight: number,
  image: ?Image
};

export type CategoriesApiItem = {
  cat_id: string,
  cat_sort_order: string,
  translation: string,
  image?: ImageApiItem
};

export default function modelCategory(item: CategoriesApiItem): Category {
  return {
    id: int(item.cat_id),
    title: item.translation,
    weight: int(item.cat_sort_order),
    image: item.image ? modelImage(item.image) : null
  };
}



// WEBPACK FOOTER //
// ./src/redux/models/category.js